import LoadingSpinner from "../LoadingSpinner";
/**
 * Loading fallback component
 */
const PageLoadingFallback = ({ message = "Loading..." }) => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <LoadingSpinner size="lg" text={message} />
  </div>
);

export default PageLoadingFallback;
